export default function Dashboard() {
  return <>Dashboard</>;
}